import { render, staticRenderFns } from "./TransactionCreate.vue?vue&type=template&id=f2cda930"
import script from "../../controllers/transaction/transaction-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/transaction/transaction-create.js?vue&type=script&lang=js&external"
import style0 from "./TransactionCreate.vue?vue&type=style&index=0&id=f2cda930&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports